<script lang="ts">
  import Portal from 'svelte-portal'

  let {
    id = '',
    show = false,
    class: classNames = '',
    trigger,
    title,
    content,
    onShow = () => {},
    onClose = () => {},
    ...restProps
  } = $props()

  let showing = $state(show)

  function toggle() {
    showing = !showing
  }

  $effect(() => {
    if (showing) {
      onShow()
      document.querySelector("body").classList.add("modal-showing")
    } else {
      onClose()
      document.querySelector("body").classList.remove("modal-showing")
    }
  })

</script>
<div class="ModalWindow" {...restProps}>
  {@render trigger?.(toggle)}

  <Portal target="#modals-portal">
    <div class="modal-wrapper {classNames}">
      <div class="modal-window" class:active={showing}>
        <div class="modal-inner">
          <div class="modal-title">
            {@render title?.()}
            <button class="btn btn-close modal-close" onclick={() => showing = false} aria-label="Close"></button>
          </div>
          <div class="modal-content">
            {@render content?.()}
          </div>
        </div>
      </div>
    </div>
  </Portal>

</div>
